module.exports = __webpack_public_path__ + "static/media/cientik_logo.ddae240d.svg";